/* eslint-disable no-useless-escape */
export type postalCodeRegexProps = {
	countryCode: string
	rule: string
}

export const postalCodeRegex: postalCodeRegexProps[] = [
	// TODO: complete regex for other countries
	{
		countryCode: "FR",
		rule: "^\\d{5}$",
	},
]
